import { HTTP_REQUEST_TYPE, CONTRAIL_API } from "../constants/api";
import { sendHttpRequest } from "./api";

const getContrailWhitelist = async () => {
	const [, resp] = await sendHttpRequest(
		HTTP_REQUEST_TYPE.get,
		CONTRAIL_API.GET_CONTRAIL_WHITELIST,
		{}
	);
	return resp;
};

interface createContrailWhitelistPayload {
	ufi: string;
	requestBy: string;
	status: string;
}

const createContrailWhitelist = async (createPayload: createContrailWhitelistPayload) => {
	const [, resp] = await sendHttpRequest(
		HTTP_REQUEST_TYPE.post,
		CONTRAIL_API.CREATE_CONTRAIL_WHITELIST,
		{
			...createPayload
		}
	);
	return resp;
};


export {
	getContrailWhitelist,
	createContrailWhitelist,
};